<template>
  <div>
    <!-- Tela Normal (printMode = false) -->
    <div v-if="!printMode">
      <h6>Estoque de Produtos</h6>
      <p></p>
      <div class="row mb-3">
        <div class="col-auto">
          <button @click="abrirPrint" class="btn btn-primary">
            Executar
          </button>
        </div>
      </div>
    </div>

    <!-- Modo Impressão (printMode = true) -->
    <div v-else>
      <div v-if="loading">Carregando…</div>

      <div v-else-if="itens.length">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>Produto</th>
              <th>Atualizado</th>
              <th class="text-center">Atual</th>
              <th class="text-center">Mínimo</th>
            </tr>
          </thead>
            <tbody>
            <tr
                v-for="(item, idx) in itens"
                :key="idx"
            >
                <td>{{ item.codigo }}</td>

                <td
                :data-estoque-critico="item.estoque < item.estoque_minimo ? 'true' : 'false'"
                :class="{
                    'text-danger': item.estoque < item.estoque_minimo,
                    'text-primary': item.estoque >= item.estoque_minimo
                }"
                >
                {{ item.nome }}
                </td>

                <td>{{ formatarAtualizado(item) }}</td>
                <td class="text-center">{{ item.estoque }}</td>
                <td class="text-center">{{ item.estoque_minimo }}</td>
            </tr>
            </tbody>
        </table>
        <!-- 👇 Mensagem explicativa das cores -->
        <p style="font-style: italic;">
            (*) Nome do produto em vermelho indica estoque abaixo do mínimo.
        </p>

      </div>

      <div v-else>
        <p>Nenhum produto encontrado.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'

const props = defineProps({
  printMode:  { type: Boolean, default: false },
  printTitle: String
})

const router   = useRouter()
const loading  = ref(false)
const itens    = ref([])

/**
 * Carrega os dados do backend
 */
async function carregarDados () {
  loading.value = true
  try {
    const res = await axios.get('/gestao/relatorios/operacionais/estoque-produtos')
    itens.value = Array.isArray(res.data) ? res.data : []
  } catch (e) {
    console.error('Erro em EstoqueProdutos (print):', e)
    itens.value = []
  } finally {
    loading.value = false
  }
}

/**
 * Quando em modo “print”, já busca os dados
 */
onMounted(() => {
  if (props.printMode) {
    carregarDados()
  }
})

/**
 * Função disparada ao clicar em "Executar" no modo tela:
 * redireciona para a rota de impressão (ReportPrintWrapper.vue)
 */
function abrirPrint () {
  router.push({
    path: '/gestao/relatorios/print/estoque-produtos',
    query: {
      title: 'Estoque de Produtos'
    }
  })
}

/**
 * Formata string de data (YYYY-MM-DD ou ISO) para "dd/MM/yyyy"
 */
function formatarData (dateStr) {
  if (!dateStr) return ''
  const d   = new Date(dateStr)
  const dia = String(d.getDate()).padStart(2, '0')
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const ano = d.getFullYear()
  return `${dia}/${mes}/${ano}`
}

/**
 * Coluna "Atualizado":
 * data da última movimentação + " -> Venda" ou " -> Compra"
 */
function formatarAtualizado (item) {
  if (!item.data_ultima_movimentacao) {
    return ''
  }
  const data = formatarData(item.data_ultima_movimentacao)
  const tipo = item.tipo_ultima_movimentacao || ''
  return `${data} -> ${tipo}`
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}
.text-center {
  text-align: center !important;
}

</style>
